/* eslint-disable react-refresh/only-export-components */
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError
} from 'react-router';

import { BaseLayout } from '@link/shinkansen/layouts';
import TrainList from '@link/shinkansen/views/TrainList';
import SeatSelection from '@link/shinkansen/views/SeatSelection';
import Confirm from '@link/shinkansen/views/Confirm';
import Submitted from '@link/shinkansen/views/Submitted';

import { lazy, Suspense, useEffect } from 'react';

const NotFound = lazy(() => import('@link/shinkansen/views/NotFound'));

function RootErrorBoundary() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : String(error);
  useEffect(() => {
    if (message.includes('Failed to fetch dynamically imported module')) {
      location.reload();
    }
  }, [message]);
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route path="/" element={<BaseLayout />}>
        <Route index element={<TrainList />} />
        <Route path="train-list" element={<TrainList />} />
        {/* Keep the /:token/:bookingId prefix throughout the booking flow. */}
        <Route path=":token/:bookingId">
          <Route index element={<TrainList />} />
          <Route path="seat" element={<SeatSelection />} />
          <Route path="confirm" element={<Confirm />} />
          <Route path="submitted" element={<Submitted />} />
        </Route>
      </Route>
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
